__turbopack_context__.v({
  "className": "notosansarabic_6a9d1695-module__MIz4Uq__className",
  "variable": "notosansarabic_6a9d1695-module__MIz4Uq__variable",
});
